import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/css/destyle.css';
import './assets/css/global.css';
import { ApiErrorProvider } from './errorHandling/context/ApiErrorContext';

const rootElement = document.getElementById('root');

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ApiErrorProvider>
        <App />
      </ApiErrorProvider>
    </React.StrictMode>,
  );
}
